import { useEffect, useState } from 'react';

interface Particle {
  id: number;
  left: number;
  delay: number;
  duration: number;
  color: string;
}

const COLORS = ['#059669', '#f59e0b', '#3b82f6', '#ec4899', '#8b5cf6', '#f97316'];

export function Confetti({ onDone }: { onDone?: () => void }) {
  const [particles] = useState<Particle[]>(() =>
    Array.from({ length: 40 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.8,
      duration: 1.5 + Math.random() * 1.5,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
    })),
  );

  useEffect(() => {
    const maxDuration = Math.max(...particles.map((p) => p.delay + p.duration)) * 1000 + 200;
    const timer = setTimeout(() => onDone?.(), maxDuration);
    return () => clearTimeout(timer);
  }, [particles, onDone]);

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999] overflow-hidden">
      {particles.map((p) => (
        <div
          key={p.id}
          className="confetti-particle"
          style={{
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            background: p.color,
          }}
        />
      ))}
    </div>
  );
}
